import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import isNumber from '../../utils/numbers/isNumber';
import { checkChanges } from '../../utils/checkChanges';

import Overview from './Overview';
import Edit from './Edit';
import Pictures from './Pictures/List';
import UnitLayout from './UnitLayout';
import UnitLayouts from './UnitLayouts';
import Units from './Units';
import Documents from './Documents/List';
import Logo from './Logo';
import Reports from './Reports';
import Activities from './Activities';
import PanelBankers from './PanelBankers';
import PanelLawyers from './PanelLawyers';
import PackagePricing from './PackagePricing';
import Videos from './Videos/List';

import '../../styles/containers/project/unitLayouts/project.less';

export default class Project extends Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      hash: PropTypes.string,
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Overview = checkChanges(Overview)
  static Edit = checkChanges(Edit);
  static PanelBankers = checkChanges(PanelBankers);
  static PanelLawyers = checkChanges(PanelLawyers);
  static PackagePricing = checkChanges(PackagePricing);
  static Pictures = Pictures
  static UnitLayout = UnitLayout
  static UnitLayouts = UnitLayouts
  static Units = Units
  static Documents = Documents
  static Logo = Logo
  static Reports = Reports
  static Activities = Activities
  static Videos = Videos

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      pictureToken: null,
      mediaToken: null,
      documentToken: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: null,
      documents: [],
      medias: [],
    };
  }
  componentDidMount() {
    const { pathname, query } = this.props.location;
    this.fetchProject();
    if (!pathname.includes('/edit/')) {
      if (!pathname.includes('/units/') &&
      !pathname.includes('/layouts/')) {
        if (pathname.includes('/pictures/')) {
          this.fetchProjectPictures();
        }
        if (pathname.includes('/documents/')) {
          this.fetchProjectDocuments(query);
        }
        if (pathname.includes('/videos/')) {
          this.fetchProjectMedias(query);
        }
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname, query, hash, action } = nextProps.location;
    const { id } = nextProps.params;
    if (this.props.location.hash !== hash && action === 'REPLACE') return; // do not fetch if hashtag changed
    if (pathname.endsWith(`/${id}/edit/`) || pathname.endsWith(`/${id}/logo/`)) {
      this.fetchProject();
    } else if (pathname.endsWith(`/${id}/documents/`)) {
      this.fetchProjectDocuments(query);
    } else if (pathname.endsWith(`/${id}/pictures/`)) {
      this.fetchProjectPictures();
    } else if (pathname.endsWith(`/${id}/videos/`)) {
      this.fetchProjectMedias();
    } else if (pathname.endsWith(`/${id}/`)) {
      this.fetchProject();
    }
  }
  setDocuments(documents = []) {
    return new Promise((res) => {
      this.setState({
        documents: documents || [],
      }, () => {
        res(documents);
      });
    });
  }
  setMedias(medias = []) {
    return new Promise((res) => {
      this.setState({
        medias: medias || [],
      }, () => {
        res(medias);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProject() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectPictures() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/pictures/?page=1`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const pictureToken = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        pictureToken,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectDocuments(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/documents/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const documentToken = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const documents = await res.json();
      await this.setDocuments(documents);
      if (this.state.documents.length < 1 && query.page > 1) {
        query.page = 1;
        store.dispatch(replace(`/projects/${this.props.params.id}/documents/?${qs.stringify(query)}`));
      }
      // handle token.. etc
      await this.setComponentState({
        documentToken,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  async fetchProjectMedias() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.params.id}/medias/?page=1`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const mediaToken = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      await this.setComponentState({
        mediaToken,
      });
    }
    await this.setLoading(false);
  }
  newFetch = () => {
    this.fetchProject();
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        pictureToken: this.state.pictureToken,
        documentToken: this.state.documentToken,
        mediaToken: this.state.mediaToken,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        data: this.state.data,
        documents: this.state.documents,
        id: this.props.params.id,
        newFetch: this.newFetch,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/Project.jsx